import React from 'react';
import { DeleteDoctor } from './DeleteDoctor';
import { FormDoctor } from './FormDoctor';
import { Dialog } from 'primereact/dialog';
import { Button } from 'reactstrap'


export const ModalDoctor = (props) => {

    const {
        method, handleInputChange, validaciones, validaciones1,
        specialties, id_specialty, name, professional_license, phone, address, email,
        toggle, modal, loading,
        saveCreate,
        saveUpdate,
        saveDelete,
        nameInputs, addSpecialty, name_specialty, isCommercialPartner,
        // ? 
        code, username, password_microsite, generateRandomPassword,
        id_seller, listSellers, handleSelectValuesA, closeModalDoctor, whatsapp_doctor,

        handleWhatsappDoctorChange, validateWhatsappDoctor
    } = props;

    const title =
        method === "create"
            ? "Registrar Médico"
            : method === "update"
                ? "Actualizar Médico"
                : "Eliminar Médico";

    const dialogClassName =
        method === "delete"
            ? "medium-dialog delete-method"
            : "large-dialog";

    return (
        <Dialog
            header={title}
            visible={modal}
            onHide={closeModalDoctor}
            className={dialogClassName}
            blockScroll={true}
            modal
            closable={true}
            dismissableMask
            footer={
                <>



                    {
                        method === "create" && <Button
                            size="sm"
                            color="secondary"
                            type="button"
                            onClick={saveCreate}
                            disabled={loading}
                        >
                            {loading ? "Guardando" ?? "--" : "Guardar" ?? "---"}
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            size="sm"
                            color="secondary"
                            type="button"
                            onClick={saveUpdate}
                            disabled={loading}
                        >
                            {loading ? "Actualizar" ?? "--" : "Actualizar" ?? "---"}
                        </Button>
                    }
                    {
                        (method !== "create" && method !== "update") && <Button
                            size="sm"
                            type="button"
                            color="secondary"
                            onClick={saveDelete}
                            disabled={loading}
                        >
                            {loading ? "Eliminando..." : "Sí, eliminar"}

                        </Button>
                    }
                    <Button
                        size="sm"
                        color="danger"
                        type="button"
                        onClick={closeModalDoctor}
                        disabled={loading}
                    >
                        {"Cancelar" ?? "---"}
                    </Button>
                </>
            }
        >

            {
                method === "create" ?
                    <FormDoctor
                        button="Crear nuevo médico"
                        {...{ addSpecialty, name_specialty, toggle, loading, nameInputs, specialties, id_specialty, name, professional_license, phone, address, email, handleInputChange, validaciones, validaciones1, methodAction: saveCreate, isCommercialPartner, code, username, password_microsite, generateRandomPassword, id_seller, listSellers, handleSelectValuesA, closeModalDoctor, whatsapp_doctor, handleWhatsappDoctorChange, validateWhatsappDoctor }}
                    />
                    : (method === "update") ?
                        <FormDoctor
                            button="Actualizar médico"
                            {...{ toggle, nameInputs, loading, specialties, id_specialty, name, professional_license, phone, address, email, handleInputChange, validaciones, methodAction: saveUpdate, isCommercialPartner, code, username, password_microsite, generateRandomPassword, id_seller, listSellers, handleSelectValuesA, closeModalDoctor, whatsapp_doctor, handleWhatsappDoctorChange, validateWhatsappDoctor }}
                        />
                        : <DeleteDoctor
                            {...{ toggle, loading, name, saveDelete, closeModalDoctor }}
                        />
            }
        </Dialog>
    )
}
